import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SavedProvider } from "@/context/SavedContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import CookiesPage from "@/pages/Cookies";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import Sell from "@/pages/Sell";
import RemovalCompanies from "@/pages/RemovalCompanies";
import CompanyDetail from "@/pages/CompanyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import MyListings from "@/pages/MyListings";
import Inbox from "@/pages/Inbox";
import Upgrade from "@/pages/Upgrade";
import PaymentSuccess from "@/pages/PaymentSuccess";
import About from "@/pages/About";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SavedListings from "@/pages/SavedListings";
import Briefs from "@/pages/Briefs";
import NewBrief from "@/pages/NewBrief";
import BriefDetail from "@/pages/BriefDetail";
import MyBriefs from "@/pages/MyBriefs";
import AdminRoute from "@/components/AdminRoute";
import AdminLayout from "@/components/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminListings from "@/pages/admin/AdminListings";
import AdminReports from "@/pages/admin/AdminReports";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminBriefs from "@/pages/admin/AdminBriefs";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminVerifications from "@/pages/admin/AdminVerifications";
import Verification from "@/pages/Verification";
import BoostBrief from "@/pages/BoostBrief";
import CompanyDashboard from "@/pages/CompanyDashboard";
import Payouts from "@/pages/Payouts";
import Subscriptions from "@/pages/Subscriptions";
import BiddingDashboard from "@/pages/BiddingDashboard";
import AdminInvoices from "@/pages/AdminInvoices";
import AdminOffers from "@/pages/admin/AdminOffers";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";

function Shell() {
  const location = useLocation();
  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-4rem)]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/listings" element={<Listings />} />
          <Route path="/listings/:id" element={<ListingDetail />} />
          <Route path="/removal-companies" element={<RemovalCompanies />} />
          <Route path="/removal-companies/:id" element={<CompanyDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<About />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/briefs" element={<Briefs />} />
          <Route path="/briefs/new" element={<ProtectedRoute><NewBrief /></ProtectedRoute>} />
          <Route path="/briefs/:id" element={<BriefDetail />} />
          <Route path="/sell" element={<ProtectedRoute><Sell /></ProtectedRoute>} />
        <Route path="/sell/:listingId" element={<ProtectedRoute><Sell /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard/listings" element={<ProtectedRoute><MyListings /></ProtectedRoute>} />
          <Route path="/dashboard/messages" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
          <Route path="/dashboard/saved" element={<ProtectedRoute><SavedListings /></ProtectedRoute>} />
          <Route path="/dashboard/briefs" element={<ProtectedRoute><MyBriefs /></ProtectedRoute>} />
          <Route path="/dashboard/verification" element={<ProtectedRoute><Verification /></ProtectedRoute>} />
          <Route path="/dashboard/company" element={<ProtectedRoute><CompanyDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/payouts" element={<ProtectedRoute><Payouts /></ProtectedRoute>} />
          <Route path="/dashboard/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />
        <Route path="/dashboard/bidding" element={<ProtectedRoute><BiddingDashboard /></ProtectedRoute>} />
          <Route path="/briefs/:briefId/boost" element={<ProtectedRoute><BoostBrief /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route index element={<AdminOverview />} />
            <Route path="listings" element={<AdminListings />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="companies" element={<AdminCompanies />} />
            <Route path="briefs" element={<AdminBriefs />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="verifications" element={<AdminVerifications />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="offers" element={<AdminOffers />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="email-templates" element={<AdminEmailTemplates />} />
          </Route>
          <Route path="/upgrade/:listingId" element={<ProtectedRoute><Upgrade /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
        <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SavedProvider>
          <Shell />
          <Toaster richColors position="top-right" />
        </SavedProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
